/**
 * Scroll targets for Schedule Interview communication step.
 * Section ids match EmailBlockSection `sectionId` in CandidatePane / InterviewerPane.
 */
import type { InterviewCommunicationValidationErrors } from '../../../InterviewActivity/communication/validate';

const SCHEDULE_ERROR_SCROLL_ORDER: Array<{
  key: keyof InterviewCommunicationValidationErrors;
  sectionId: string;
}> = [
  { key: 'candidateCalendar', sectionId: 'schedule-comm-candidate-calendar' },
  { key: 'candidateEmail', sectionId: 'schedule-comm-candidate-email' },
  {
    key: 'interviewerCalendar',
    sectionId: 'schedule-comm-interviewer-calendar',
  },
  { key: 'interviewerEmail', sectionId: 'schedule-comm-interviewer-email' },
  { key: 'selfSchedule', sectionId: 'schedule-comm-self-schedule' },
];

export function getFirstScheduleCommunicationScrollTarget(
  errors: InterviewCommunicationValidationErrors
): string | null {
  for (const { key, sectionId } of SCHEDULE_ERROR_SCROLL_ORDER) {
    if (errors[key]) {
      return sectionId;
    }
  }
  return null;
}

export function scrollScheduleCommunicationSectionIntoView(
  sectionId: string
): void {
  const el = document.getElementById(sectionId);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
